import axios from "axios";

const LOCAL_API_URL =
  process.env.REACT_APP_LOCAL_API_URL || "http://localhost:7000";

const SHOP_CONFIG_STORAGE_KEY = "shop_config_cache";

let cachedShopConfig = null;

const defaultShopConfig = {
  shop_id: 1,
  shop_name: "POS",
  shopName: "POS",
  address: "",
  phone: "",
  receipt_footer: "Thank you for shopping with us",
  receiptFooter: "Thank you for shopping with us",
  currency: "€",
  license_key: "",
  licenseKey: "",
  vat_number: "",
  vatNumber: "",
  cloud_api_url: "https://api.deskpos.ie",
};

const buildAddress = (data = {}) => {
  if (data.address) return data.address;
  if (data.shop_address) return data.shop_address;
  if (data.shopAddress) return data.shopAddress;
  if (data.full_address) return data.full_address;
  if (data.fullAddress) return data.fullAddress;

  const parts = [
    data.address_line1 || data.addressLine1,
    data.address_line2 || data.addressLine2,
    data.city,
    data.county,
    data.postcode || data.eircode,
  ].filter(Boolean);

  return parts.join(", ");
};

const normalizeShopConfig = (data = {}) => {
  const shopName =
    data.shop_name ||
    data.shopName ||
    data.business_name ||
    data.businessName ||
    data.company_name ||
    data.companyName ||
    data.trading_name ||
    data.tradingName ||
    data.name ||
    "POS";

  const address = buildAddress(data);

  const phone =
    data.phone ||
    data.shop_phone ||
    data.shopPhone ||
    data.contact_phone ||
    data.contactPhone ||
    data.mobile ||
    data.tel ||
    "";

  const receiptFooter =
    data.receipt_footer ||
    data.receiptFooter ||
    data.footer ||
    data.footer_text ||
    data.footerText ||
    "Thank you for shopping with us";

  const licenseKey = data.license_key || data.licenseKey || "";
  const vatNumber = data.vat_number || data.vatNumber || "";

  const cloudApiUrl =
    data.cloud_api_url ||
    data.cloudApiUrl ||
    data.api_url ||
    data.apiUrl ||
    "https://api.deskpos.ie";

  return {
    shop_id: Number(data.shop_id || data.shopId || data.id || 1),

    // both versions, so old receipt/POS code can use either
    shop_name: shopName,
    shopName,

    address,
    phone,

    receipt_footer: receiptFooter,
    receiptFooter,

    currency: data.currency || "€",

    license_key: licenseKey,
    licenseKey,

    cloud_api_url: cloudApiUrl,
    cloudApiUrl,

    vat_number: vatNumber,
    vatNumber,
  };
};

const getStoredShopConfig = () => {
  try {
    const saved = localStorage.getItem(SHOP_CONFIG_STORAGE_KEY);

    if (!saved) {
      return null;
    }

    return normalizeShopConfig(JSON.parse(saved));
  } catch (err) {
    console.log("Failed to read cached shop config:", err.message);
    return null;
  }
};

const saveStoredShopConfig = (config) => {
  try {
    localStorage.setItem(SHOP_CONFIG_STORAGE_KEY, JSON.stringify(config));
  } catch (err) {
    console.log("Failed to save cached shop config:", err.message);
  }
};

export const getShopConfig = async () => {
  if (cachedShopConfig) {
    return cachedShopConfig;
  }

  const storedConfig = getStoredShopConfig();

  try {
    const res = await axios.get(`${LOCAL_API_URL}/local-config`, {
      timeout: 1500,
    });

    cachedShopConfig = normalizeShopConfig(res.data);

    saveStoredShopConfig(cachedShopConfig);

    return cachedShopConfig;
  } catch (err) {
    console.log(
      "Local shop config failed, using saved/default config:",
      err.response?.data || err.message
    );

    if (storedConfig) {
      cachedShopConfig = storedConfig;
      return cachedShopConfig;
    }

    cachedShopConfig = defaultShopConfig;
    return cachedShopConfig;
  }
};

export const clearShopConfigCache = () => {
  cachedShopConfig = null;
  localStorage.removeItem(SHOP_CONFIG_STORAGE_KEY);
};